import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { useForm } from 'react-hook-form';
import AutocompleteDropdown from 'componentes/generic/AutoComplete.js';
import NotificationAlert from 'componentes/generic/Notification.js';
const URI = ApiEndpoint + 'configuration/';

const EditCp = ({ idCp, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [states, setStates] = useState(null);

  const [municipios, setMunicipios] = useState(null);
  const [selectedEstado, setSelectedEstado] = useState(null);

  const [selectedMunicipioDescription, setSelectedMunicipioDescription] =
    useState(null);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMesagge, setErrorMesagge] = useState(null);

  const [cp, setCp] = useState({
    idmunicipio: '0',
    codigopostal: '',
    municipio: ''
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();
  const getStatesList = async () => {
    setStates(null);

    httpClient('GET', URI + 'states', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setStates(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getMunicipiosList = async idState => {
    setMunicipios(null);

    httpClient('GET', URI + 'cities/' + idState, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setMunicipios(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getCp = async () => {
    setCp(null);

    httpClient('GET', URI + 'codigopostal/' + idCp, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setSelectedEstado(response.data.municipio.idestado);
          setSelectedMunicipioDescription(response.data.municipio.descripcion);
          setValue('codigopostal', response.data.codigopostal);
          setValue('descripcion', response.data.descripcion);
          setValue('idmunicipio', response.data.idmunicipio);
          setValue('estado', response.data.municipio.idestado);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    if (idCp > 0) getCp();
    getStatesList();
  }, []);
  useEffect(() => {
    if (selectedEstado > 0) getMunicipiosList(selectedEstado);
  }, [selectedEstado]);

  const onSubmit = data => {
    console.log(data);

    if (idCp > 0) {
      httpClient(
        'put',
        URI + 'codigopostal/' + idCp,
        {
          idcodigopostal: idCp,
          codigopostal: data.codigopostal,
          idmunicipio: data.idmunicipio
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'codigopostal',
        {
          codigopostal: data.codigopostal,
          idmunicipio: data.idmunicipio
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  return (
    <>
      <Card style={{ width: '100%' }}>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Estado</Form.Label>
                  <select
                    aria-label="Default select"
                    name="estado"
                    id="estado"
                    className="form-control"
                    {...register('estado', {
                      required: 'Campo Requerido'
                    })}
                    onChange={e => {
                      setValue('estado', e.target.value, {
                        shouldValidate: true
                      });
                      setSelectedEstado(e.target.value);
                      getMunicipiosList(e.target.value);
                    }}
                    value={`${selectedEstado}`}
                    style={{ minWidth: '250px' }}
                  >
                    <option key={'location_0'} value="">
                      Selecciona un estado
                    </option>
                    {!!states?.length &&
                      states.map(estado => (
                        <option key={estado.idestado} value={estado.idestado}>
                          {estado.descripcion}
                        </option>
                      ))}
                  </select>
                  <Form.Control.Feedback type="invalid">
                    {errors.estado?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                {municipios && municipios.length > 0 && (
                  <AutocompleteDropdown
                    items={
                      !municipios
                        ? []
                        : municipios.map(municipio => {
                            return {
                              id: municipio.idmunicipio,
                              description: municipio.descripcion
                            };
                          })
                    }
                    placeholder="Selecciona un municipio"
                    register={register}
                    errors={errors}
                    name="idmunicipio"
                    currentSelected={selectedMunicipioDescription}
                    setCurrentSelected={value => {
                      setValue('idmunicipio', value, { shouldValidate: true });
                    }}
                    setValue={setValue}
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Codigo Postal</Form.Label>
                  <FormControl
                    {...register('codigopostal', {
                      pattern: {
                        value: /^[0-9]{5}$/,
                        message:
                          'El Codigo Postal debe tener exactamente 5 números'
                      }
                    })}
                    type="text"
                    defaultValue={cp?.codigopostal}
                    isInvalid={!!errors.codigopostal}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.codigopostal?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
      />
    </>
  );
};
EditCp.propTypes = {
  idCp: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};

export default EditCp;
